import { render, staticRenderFns } from "./header-marketing.vue?vue&type=template&id=27c2a343"
import script from "./header-marketing.vue?vue&type=script&lang=ts"
export * from "./header-marketing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports